import { wechatLauncherUserService, wechatLauncherPlatformService, wechatLauncherPlatformService1, wechatLauncherDynamicService, rjhyUser, wechatUserService, wechatPromotionService} from './instance.js'
import qs from 'qs'
import url from 'url'
let query = url.parse(window.location.toString(), true).query
import {getSignHeader} from '@/utils/getSignHeader.js'

export const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  ret = ret.slice(0, -1)
  return ret
}]

export const getUserByCode = async (code, originId) => {
  let params =  {
    code, originId
  }
  let headers = getSignHeader(params)
  headers['Content-Type'] = 'application/json'
  return await wechatLauncherPlatformService.get(`api/platform/auth/web/token/code`, {
    params, headers
  })
}

export const getMiniQrCode = async ({originId, scene, page}) => {
  let params =  {
    originId,
    scene,
    page
  }
  let headers = getSignHeader(params)
  headers['Content-Type'] = 'application/json'
  return await wechatLauncherPlatformService1.get(`api/platform/auth/aCodeUnlimited`, {
    params, headers
  })
}

export const getSignature = async ({url, originId}) => {
  let params = {
    url, originId
  }
  let headers = getSignHeader(params)
  headers['Content-Type'] = 'application/json'
  const res = await wechatLauncherPlatformService.get(`api/platform/auth/jsconfig`, {
    params,
    headers
  })
  return res.data.result
}

export const getConfigService = async () => {
  let params = {
    key: query.key
  }
  let headers = getSignHeader(params)
  headers['Content-Type'] = 'application/json'
  const res = await wechatLauncherDynamicService.get(`config/analysis`, {
    params, headers
  })
  if (res.data.code !== 1) return {}
  return res.data.data
}

export const rjhyUserLogin = async ({openid, accessToken, sex, nickname, serverId, reffer, activityId, headimgurl, unionid}) => {
  let params =  {
    unionid,
    serverId,
    openid,
    nickname,
    sex,
    headimgurl,
    reffer,
    activityId,
    accessToken
  }
  let headers = getSignHeader(params)
  return await wechatLauncherUserService.post(`/api/1/user/wechat-xltz/wx/login`, qs.stringify(params), {headers})
}

export const getUserByToken = async (params) => {
  let headers = getSignHeader(params)
  const res = await rjhyUser.get('', {
    params, headers
  })
  return res && res.data
}

export const getUserByUnionId = async (params) => {
  let headers = getSignHeader(params)
  const res = await wechatUserService.get('', {
    params, headers
  })
  return res && res.data
}

export const querySubscribeApi = async (params) =>{
  let headers = getSignHeader(params)
  const res =  await wechatPromotionService.post(`/api/v1/weChat/subscribe/query`, params, {headers})
  return res.data
}

export const queryTemplateConfigInfoApi = async (params) => {
  let headers = getSignHeader(params)
  const res =  await wechatPromotionService.get(`/api/v1/weChat/subscribe/config/h5/query`, {
    params, headers
  })
  return res.data
}